import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-665973d2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "Platform" }
const _hoisted_2 = { class: "Platform-main viewport" }

import { reactive, watch, onMounted, onBeforeMount } from 'vue'
import { useRoute } from 'vue-router'
import { navList } from '@/assets/js/platform/nav'
import Category from '@/components/bussiness/Category/Category.vue'
import NavBar from './components/NavBar.vue'
import PlatformMain from './components/PlatformMain.vue'
import router from '@/router'
import { useSite2Station } from '@/store'
import { Site } from '@/common/const'

enum Params {
  taobao = 'taobao',

  tmall = 'tmall',

  _1688 = '1688',
}


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const route = useRoute()
const stationCode = useSite2Station()

// 监听id改变
watch(
  () => route.params.type,
  (val) => {
    data.type = val
  }
)

const data: any = reactive({
  type: route.params.type
})

onBeforeMount(() => {
  // 韩国站没翻译，所以重定向
  if (stationCode === Site.JA) return

  const path = route.path
  const paths = path.split('/')
  const type = paths[paths.length - 1]
  let replaceUrl = ''

  switch (type) {
    case Params.taobao:
      replaceUrl = 'https://world.taobao.com/'
      break
    case Params.tmall:
      replaceUrl = 'https://www.tmall.com/'
      break
    case Params._1688:

      replaceUrl = 'https://www.1688.com/'
      break

    default:
      break
  }
  // 因为翻译的问题，这个直接导向对应的网站
  location.href = replaceUrl
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(Category),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(NavBar, {
        navList: _unref(navList),
        type: _unref(data).type
      }, null, 8, ["navList", "type"]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(navList), (item) => {
        return (_openBlock(), _createElementBlock(_Fragment, {
          key: item.value
        }, [
          (item.value === _unref(data).type)
            ? (_openBlock(), _createBlock(PlatformMain, {
                key: 0,
                navItem: item
              }, null, 8, ["navItem"]))
            : _createCommentVNode("", true)
        ], 64))
      }), 128))
    ])
  ]))
}
}

})